// StatsCard.tsx
import React from "react"
import { Link } from "react-router-dom"

interface StatsCardProps {
  title: string
  count: number
  iconSrc: string       // ✅ Required
  iconBg: string
  linkTo: string
  onClick: () => void
}

const StatsCard: React.FC<StatsCardProps> = ({ title, count, iconSrc, iconBg, linkTo, onClick }) => {
  return (
    <Link to={linkTo} onClick={onClick}>
      <div className="bg-white shadow rounded-lg p-4 hover:shadow-md transition">
        <div className="flex items-center">
          <div className={`w-14 h-14 rounded-full flex items-center justify-center ${iconBg}`}>
            <img src={iconSrc} alt={title} className="w-12 h-12" />
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-medium text-gray-700">{title}</h3>
            <p className="text-2xl font-bold text-gray-900">{count}</p>
          </div>
        </div>
      </div>
    </Link>
  )
}

export default StatsCard
